// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file notification_service.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptyMessageRequestSchema, MessageResponseSchema } from "./general_pb";
import { file_general } from "./general_pb";
import type { NotificationChannel, NotificationChannelJson, NotificationEvent, NotificationEventJson } from "./notification_pb";
import { file_notification } from "./notification_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file notification_service.proto.
 */
export const file_notification_service: GenFile = /*@__PURE__*/
  fileDesc("Chpub3RpZmljYXRpb25fc2VydmljZS5wcm90bxIJcmFjY29vbmFpIo0BCiFOb3RpZnlSZWNlaXZlckpvYkNvbXBsZXRlZFJlcXVlc3QSFgoGam9iX2lkGAEgAigEUgZqb2JfaWQSHgoKY29udGFjdF9pZBgCIAIoBFIKY29udGFjdF9pZBIwChNzZXJ2aWNlX3Byb3ZpZGVyX2lkGAMgAigEUhNzZXJ2aWNlX3Byb3ZpZGVyX2lkIrABChZOb3RpZmljYXRpb25QcmVmZXJlbmNlEisKBWV2ZW50GAEgAigOMhwucmFjY29vbmFpLk5vdGlmaWNhdGlvbkV2ZW50EjAKCGNoYW5uZWxzGAIgAygOMh4ucmFjY29vbmFpLk5vdGlmaWNhdGlvbkNoYW5uZWwSKAoPb3B0X291dF9hbGxvd2VkGAMgAigIUg9vcHRfb3V0X2FsbG93ZWQSDQoFbXV0ZWQYBCACKAgiVAoaTm90aWZpY2F0aW9uUHJlZmVyZW5jZUxpc3QSNgoLcHJlZmVyZW5jZXMYASADKAsyIS5yYWNjb29uYWkuTm90aWZpY2F0aW9uUHJlZmVyZW5jZSJaChxOb3RpZmljYXRpb25QcmVmZXJlbmNlVXBkYXRlEisKBWV2ZW50GAEgAigOMhwucmFjY29vbmFpLk5vdGlmaWNhdGlvbkV2ZW50Eg0KBW11dGVkGAIgAigIMtQCChNOb3RpZmljYXRpb25TZXJ2aWNlEmgKGk5vdGlmeVJlY2VpdmVySm9iQ29tcGxldGVkEiwucmFjY29vbmFpLk5vdGlmeVJlY2VpdmVySm9iQ29tcGxldGVkUmVxdWVzdBoaLnJhY2Nvb25haS5NZXNzYWdlUmVzcG9uc2UiABJlChpHZXROb3RpZmljYXRpb25QcmVmZXJlbmNlcxIeLnJhY2Nvb25haS5FbXB0eU1lc3NhZ2VSZXF1ZXN0GiUucmFjY29vbmFpLk5vdGlmaWNhdGlvblByZWZlcmVuY2VMaXN0IgASbAocVXBkYXRlTm90aWZpY2F0aW9uUHJlZmVyZW5jZRInLnJhY2Nvb25haS5Ob3RpZmljYXRpb25QcmVmZXJlbmNlVXBkYXRlGiEucmFjY29vbmFpLk5vdGlmaWNhdGlvblByZWZlcmVuY2UiAEIGWgQuL3Bi", [file_general, file_notification]);

/**
 * @generated from message raccoonai.NotifyReceiverJobCompletedRequest
 */
export type NotifyReceiverJobCompletedRequest = Message<"raccoonai.NotifyReceiverJobCompletedRequest"> & {
  /**
   * @generated from field: required uint64 job_id = 1 [json_name = "job_id"];
   */
  jobId: bigint;

  /**
   * @generated from field: required uint64 contact_id = 2 [json_name = "contact_id"];
   */
  contactId: bigint;

  /**
   * @generated from field: required uint64 service_provider_id = 3 [json_name = "service_provider_id"];
   */
  serviceProviderId: bigint;
};

/**
 * @generated from message raccoonai.NotifyReceiverJobCompletedRequest
 */
export type NotifyReceiverJobCompletedRequestJson = {
  /**
   * @generated from field: required uint64 job_id = 1 [json_name = "job_id"];
   */
  job_id?: string;

  /**
   * @generated from field: required uint64 contact_id = 2 [json_name = "contact_id"];
   */
  contact_id?: string;

  /**
   * @generated from field: required uint64 service_provider_id = 3 [json_name = "service_provider_id"];
   */
  service_provider_id?: string;
};

/**
 * Describes the message raccoonai.NotifyReceiverJobCompletedRequest.
 * Use `create(NotifyReceiverJobCompletedRequestSchema)` to create a new message.
 */
export const NotifyReceiverJobCompletedRequestSchema: GenMessage<NotifyReceiverJobCompletedRequest, {jsonType: NotifyReceiverJobCompletedRequestJson}> = /*@__PURE__*/
  messageDesc(file_notification_service, 0);

/**
 * The caller's effective setting for one event, derived from their service
 * provider's NotificationRule.
 *
 * @generated from message raccoonai.NotificationPreference
 */
export type NotificationPreference = Message<"raccoonai.NotificationPreference"> & {
  /**
   * @generated from field: required raccoonai.NotificationEvent event = 1;
   */
  event: NotificationEvent;

  /**
   * @generated from field: repeated raccoonai.NotificationChannel channels = 2;
   */
  channels: NotificationChannel[];

  /**
   * false: muted cannot be changed
   *
   * @generated from field: required bool opt_out_allowed = 3 [json_name = "opt_out_allowed"];
   */
  optOutAllowed: boolean;

  /**
   * false when nothing stored
   *
   * @generated from field: required bool muted = 4;
   */
  muted: boolean;
};

/**
 * The caller's effective setting for one event, derived from their service
 * provider's NotificationRule.
 *
 * @generated from message raccoonai.NotificationPreference
 */
export type NotificationPreferenceJson = {
  /**
   * @generated from field: required raccoonai.NotificationEvent event = 1;
   */
  event?: NotificationEventJson;

  /**
   * @generated from field: repeated raccoonai.NotificationChannel channels = 2;
   */
  channels?: NotificationChannelJson[];

  /**
   * false: muted cannot be changed
   *
   * @generated from field: required bool opt_out_allowed = 3 [json_name = "opt_out_allowed"];
   */
  opt_out_allowed?: boolean;

  /**
   * false when nothing stored
   *
   * @generated from field: required bool muted = 4;
   */
  muted?: boolean;
};

/**
 * Describes the message raccoonai.NotificationPreference.
 * Use `create(NotificationPreferenceSchema)` to create a new message.
 */
export const NotificationPreferenceSchema: GenMessage<NotificationPreference, {jsonType: NotificationPreferenceJson}> = /*@__PURE__*/
  messageDesc(file_notification_service, 1);

/**
 * @generated from message raccoonai.NotificationPreferenceList
 */
export type NotificationPreferenceList = Message<"raccoonai.NotificationPreferenceList"> & {
  /**
   * @generated from field: repeated raccoonai.NotificationPreference preferences = 1;
   */
  preferences: NotificationPreference[];
};

/**
 * @generated from message raccoonai.NotificationPreferenceList
 */
export type NotificationPreferenceListJson = {
  /**
   * @generated from field: repeated raccoonai.NotificationPreference preferences = 1;
   */
  preferences?: NotificationPreferenceJson[];
};

/**
 * Describes the message raccoonai.NotificationPreferenceList.
 * Use `create(NotificationPreferenceListSchema)` to create a new message.
 */
export const NotificationPreferenceListSchema: GenMessage<NotificationPreferenceList, {jsonType: NotificationPreferenceListJson}> = /*@__PURE__*/
  messageDesc(file_notification_service, 2);

/**
 * @generated from message raccoonai.NotificationPreferenceUpdate
 */
export type NotificationPreferenceUpdate = Message<"raccoonai.NotificationPreferenceUpdate"> & {
  /**
   * @generated from field: required raccoonai.NotificationEvent event = 1;
   */
  event: NotificationEvent;

  /**
   * @generated from field: required bool muted = 2;
   */
  muted: boolean;
};

/**
 * @generated from message raccoonai.NotificationPreferenceUpdate
 */
export type NotificationPreferenceUpdateJson = {
  /**
   * @generated from field: required raccoonai.NotificationEvent event = 1;
   */
  event?: NotificationEventJson;

  /**
   * @generated from field: required bool muted = 2;
   */
  muted?: boolean;
};

/**
 * Describes the message raccoonai.NotificationPreferenceUpdate.
 * Use `create(NotificationPreferenceUpdateSchema)` to create a new message.
 */
export const NotificationPreferenceUpdateSchema: GenMessage<NotificationPreferenceUpdate, {jsonType: NotificationPreferenceUpdateJson}> = /*@__PURE__*/
  messageDesc(file_notification_service, 3);

/**
 * @generated from service raccoonai.NotificationService
 */
export const NotificationService: GenService<{
  /**
   * @generated from rpc raccoonai.NotificationService.NotifyReceiverJobCompleted
   */
  notifyReceiverJobCompleted: {
    methodKind: "unary";
    input: typeof NotifyReceiverJobCompletedRequestSchema;
    output: typeof MessageResponseSchema;
  },
  /**
   * Preferences of the authenticated caller. One entry per event the caller's
   * provider has a rule for.
   *
   * @generated from rpc raccoonai.NotificationService.GetNotificationPreferences
   */
  getNotificationPreferences: {
    methodKind: "unary";
    input: typeof EmptyMessageRequestSchema;
    output: typeof NotificationPreferenceListSchema;
  },
  /**
   * Mutes or unmutes one event for the authenticated caller. permission_denied
   * when the rule has opt_out_allowed = false; not_found when there is no rule.
   *
   * @generated from rpc raccoonai.NotificationService.UpdateNotificationPreference
   */
  updateNotificationPreference: {
    methodKind: "unary";
    input: typeof NotificationPreferenceUpdateSchema;
    output: typeof NotificationPreferenceSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_notification_service, 0);

